import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBlogListing } from "../../store/Slice/blogListingSlice";
import { getBlogCategoryListing } from "../../store/Slice/blogCategoryListingSlice";

import { useLocation, useNavigate } from "react-router-dom";
import PopularBlogs from "./PopularBlogs";
import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";
import CategorySkeleton from "../../skeleton/CategorySkeleton";
import BlogCardSkeleton from "../../skeleton/BlogSkeleton";

const Blog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const noImage = "/assets/images/no-image.png";

  const [categoryClick, setCategoryClick] = React.useState(false);

  const [selectedCategoryIds, setSelectedCategoryIds] = React.useState([]);

  const [filterCategoryData, setFilterCategoryData] = React.useState([]);

  const [showSkeleton, setShowSkeleton] = React.useState(false);

  const [currentPage, setCurrentPage] = React.useState(1);
  const pageSize = 9;

  const { blogListingData, loading: blogListingLoading } = useSelector(
    (state) => state.blogListing
  );
  const { blogCategoryListingData, loading: blogCategoryLoading } = useSelector(
    (state) => state.blogCategoryListing
  );

  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const path = location.pathname === "/" ? "home" : location.pathname.slice(1);

  React.useEffect(() => {
    dispatch(getBlogListing());
    setShowSkeleton(true);
  }, [dispatch]);

  React.useEffect(() => {
    if (blogListingData && blogListingData.code === 200) {
      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [blogListingData]);

  React.useEffect(() => {
    setShowSkeleton(true);
    dispatch(getBlogCategoryListing());
  }, [dispatch]);

  React.useEffect(() => {
    if (blogCategoryListingData && blogCategoryListingData.code === 200) {
      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [blogCategoryListingData]);

  const isStillBlogListingLoading = React.useMemo(
    () =>
      blogListingLoading ||
      !blogListingData ||
      typeof blogListingData.code === "undefined",
    [blogListingLoading, blogListingData]
  );

  const isStillBlogCategoryLoading = React.useMemo(
    () =>
      blogCategoryLoading ||
      !blogCategoryListingData ||
      typeof blogCategoryListingData.code === "undefined",
    [blogCategoryLoading, blogCategoryListingData]
  );

  const handleBlogClick = (blogId, blogSlug) => {
    navigate(`/blog-detail/${blogSlug}`, {
      state: { blogId },
    });
  };

  const handleCategoryClick = (categoryId) => {
    setCategoryClick(true);
    setSelectedCategoryIds((prevIds) =>
      prevIds.includes(categoryId)
        ? prevIds.filter((id) => id !== categoryId)
        : [...prevIds, categoryId]
    );
  };

  React.useEffect(() => {
    if (!blogListingData || blogListingData.code !== 200) return;

    if (categoryClick && selectedCategoryIds.length > 0) {
      const relatedCategoryData =
        blogListingData &&
        blogListingData.code === 200 &&
        blogListingData.data.filter((item) =>
          selectedCategoryIds.includes(item.iCategoryId)
        );

      setFilterCategoryData(relatedCategoryData);
    } else {
      setFilterCategoryData([]);
    }
  }, [categoryClick, blogListingData, selectedCategoryIds]);

  const finalData = React.useMemo(() => {
    if (categoryClick && selectedCategoryIds.length > 0) {
      return filterCategoryData && filterCategoryData.length > 0
        ? filterCategoryData
        : [];
    } else {
      return blogListingData?.data?.length > 0 ? blogListingData.data : [];
    }
  }, [categoryClick, selectedCategoryIds, filterCategoryData, blogListingData]);

  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return finalData.slice(startIndex, startIndex + pageSize);
  }, [finalData, currentPage]);

  const totalPages = Math.ceil(finalData.length / pageSize);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // setShowSkeleton(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [path, dispatch]);

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const blogsHeading = labelMap.get("LBL_BLOGS_HEADING") || "";
  const categoriesHeading = labelMap.get("LBL_BLOGS_CATEGORIES_HEADING") || "";
  const popularBlogsHeading =
    labelMap.get("LBL_BLOGS_POPULAR_BLOGS_HEADING") || "";

  const handleCloseCategory = (e, categoryId) => {
    e.stopPropagation();
    setSelectedCategoryIds((prevIds) =>
      prevIds.filter((id) => id !== categoryId)
    );

    if (selectedCategoryIds.length <= 1) {
      setCategoryClick(false); // if none left, reset click state
    }
  };

  const renderBlogs = (blogs) => {
    if (!blogs || blogs.length === 0) {
      return (
        <div className="col-12">
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "100px 0",
            }}
          >
            No Data Found
          </p>
        </div>
      );
    }
    return [...blogs]
      .sort((a, b) => new Date(b.dtAddedDate) - new Date(a.dtAddedDate))
      .map((blog, blogIndex) => (
        <div className="col-xl-4 col-lg-6 col-md-6" key={blogIndex}>
          <div className="blog-maincard">
            <div className="blog-cardimgDiv">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => handleBlogClick(blog.iBlogId, blog.vSlug)}
                className="blog-cardimg"
                width={307}
                height={200}
                // src="/assets/images/blog/blog1.png"
                src={
                  blog?.vWebpImage && !blog?.vWebpImage.endsWith(null)
                    ? blog?.vWebpImage
                    : noImage
                }
                alt={blog?.vImageAlt}
              />
              <span
                className="blogviewdate"
                style={{ cursor: "pointer" }}
                onClick={() => handleBlogClick(blog.iBlogId, blog.vSlug)}
              >
                {blog?.dtAddedDate}
              </span>
            </div>
            <div className="blogcard-content">
              <div className="blogtype-dateDiv">
                {blog && blog.category && (
                  <span
                    className="blogclean-type"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleBlogClick(blog.iBlogId, blog.vSlug)}
                  >
                    {blog.category.vCategory}
                  </span>
                )}
              </div>
              <div
                className="text-decoration-none"
                style={{ cursor: "pointer" }}
                onClick={() => handleBlogClick(blog.iBlogId, blog.vSlug)}
              >
                <h2 className="medium-title">{blog.vBlog}</h2>
              </div>

              <div
                className="blog-cont"
                style={{ cursor: "pointer" }}
                onClick={() => handleBlogClick(blog.iBlogId, blog.vSlug)}
                dangerouslySetInnerHTML={{ __html: blog.tDescription }}
              />
            </div>
          </div>
        </div>
      ));
  };

  const measureTextWidth = (text, font = '14px "Poppins", sans-serif') => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width + 40; // + padding/margin/icon space
  };

  const categoryWidths = React.useMemo(() => {
    if (!blogCategoryListingData?.data) return [];

    return blogCategoryListingData.data.map(
      (cat) => `${measureTextWidth(cat.vCategory)}px`
    );
  }, [blogCategoryListingData]);

  return (
    <section className="blogpage-section  pt-50 pb-50">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <h2 className="main-title">{blogsHeading}</h2>
          </div>
        </div>
        <div className="row g-lg-5 g-4">
          <div className="col-xl-8 col-lg-8 blog-scrollcotnent">
            <div className="row g-lg-4 g-4">
              {isStillBlogListingLoading || showSkeleton ? (
                <BlogCardSkeleton count={blogListingData?.data?.length} />
              ) : blogListingData &&
                blogListingData?.code === 200 &&
                blogListingData?.data ? (
                renderBlogs(paginatedData)
              ) : (
                <div className="col-12">
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 0",
                    }}
                  >
                    No Data Found
                  </p>
                </div>
              )}
            </div>

            {totalPages > 1 && (
              <div className="row pt-50">
                <div className="col-lg-12">
                  <nav
                    aria-label="Page navigation example"
                    className="blog-pagination"
                  >
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          aria-label="Previous"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          <span aria-hidden="true">
                            <i className="fa fa-angle-left"></i>
                          </span>
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            // className="page-link active"
                            className={`page-link ${
                              currentPage === index + 1 ? "active" : ""
                            }`}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}

                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          aria-label="Next"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          <span aria-hidden="true">
                            <i className="fa fa-angle-right"></i>
                          </span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
          <div className="col-xl-4 col-lg-4 ">
            <div className="d-flex flex-column gap-lg-4 gap-4">
              <div className="categories-card">
                <h3 className="medium-title">{categoriesHeading}</h3>
                {isStillBlogCategoryLoading || showSkeleton ? (
                  <CategorySkeleton
                    count={blogCategoryListingData?.data?.length}
                    widths={categoryWidths}
                  />
                ) : blogCategoryListingData &&
                  blogCategoryListingData.code === 200 &&
                  blogCategoryListingData.data ? (
                  <div className="categories-listblog">
                    {blogCategoryListingData.data.map(
                      (category, categoryIndex) => (
                        <div
                          style={{ cursor: "pointer" }}
                          key={categoryIndex}
                          className={`categories-types ${
                            selectedCategoryIds.includes(category.iCategoryId)
                              ? "selected"
                              : ""
                          }`}
                          onClick={() =>
                            handleCategoryClick(category.iCategoryId)
                          }
                        >
                          {category.vCategory}
                          {/* Separate div for the icon */}
                          {selectedCategoryIds.includes(
                            category.iCategoryId
                          ) && (
                            <div
                              className="icon-container"
                              onClick={(e) =>
                                handleCloseCategory(e, category.iCategoryId)
                              }
                            >
                              <i className="fa fa-close"></i>
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div className="col-12">
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px 0",
                      }}
                    >
                      No Data Found
                    </p>
                  </div>
                )}
              </div>

              {/* <div className="categories-card">
                  <h3 className="medium-title">Tags</h3>
                  {isStillTagLoading ? null : tagListingData &&
                    tagListingData.code === 200 &&
                    tagListingData.data ? (
                    <div className="categories-listblog">
                      {tagListingData.data.map((tag, tagIndex) => (
                        <div
                          className="categories-types"
                          key={tagIndex}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleTagClick(tag.iTagId)}
                        >
                          {tag.vTag}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="col-12">
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "10px 0",
                        }}
                      >
                        No Data Found
                      </p>
                    </div>
                  )}
                </div> */}

              <PopularBlogs
                blogListingData={blogListingData}
                blogListingLoading={blogListingLoading}
                popularBlogsHeading={popularBlogsHeading}
                showSkeleton={showSkeleton}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
